/**
 * Best-effort message extractor for unknown error values.
 */
export const safelyGetErrorMessage = (error: unknown, fallback = 'There has been an error.') => {
  try {
    if (typeof error === 'string') {
      return error;
    }
    if (typeof error === 'object' && error !== null && 'message' in error) {
      const message = (error as { message?: unknown }).message;
      return typeof message === 'string' ? message : fallback;
    }
    return fallback;
  } catch {
    return fallback;
  }
};

/**
 * Best-effort error code extractor.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safelyGetErrorCode = (error: any, fallback = 'unknown') => {
  if (typeof error === 'string') {
    return error;
  }
  return error?.extra?.code || error?.code || fallback;
};
